import { useTranslation, Trans } from "react-i18next";

import { ValidSource, validSourceLabelMap } from "@validator/schema";
import { Tab } from "@shared/components/Tabs";

import { tc } from "@/components/i18n";

import * as R from "remeda";

export function ServiceExportInstructions({ service }: { service: ValidSource }) {
  const { t } = useTranslation(undefined, {
    keyPrefix: `exportInstructions.${service}` as const,
  });
  const stepKeys = R.keys(t("steps", { returnObjects: true }));

  if (stepKeys.length === 0) return null;

  return (
    <ol className="list-decimal list-outside pl-5 space-y-3">
      {R.map(stepKeys, (k) => (
        <li key={k}>
          <Trans t={t} i18nKey={`steps.${k}`} components={tc} />
        </li>
      ))}
    </ol>
  );
}

interface InstructionsTabsProps {
  tab: ValidSource;
  onChange: (tab: ValidSource) => void;
}

function InstructionsTabs({ tab, onChange }: InstructionsTabsProps) {
  const tabs = R.entries(validSourceLabelMap);

  return (
    <fieldset className="flex mb-5 gap-x-2" aria-label="Export instructions">
      {R.map(tabs, ([key, name]) => (
        <Tab
          key={key}
          name="instructions-tab"
          value={key}
          selected={key === tab}
          onChange={() => onChange(key)}
          text={name}
        />
      ))}
    </fieldset>
  );
}

export function ExportInstructions({ tab, onChange }: InstructionsTabsProps) {
  return (
    <>
      <InstructionsTabs tab={tab} onChange={onChange} />
      <ServiceExportInstructions service={tab} />
    </>
  );
}
